
<div
      usbLoadingSplash
      [appLoading]="appLoading"
      [fullscreen]="true"
      [component]="'detailSummary'">
    </div>

<div id="bg-resumen" style="background-color: #f0eef4 !important;">
  <div class="top-summary" style="font-family: Poppins;">
    <div class="pt-5" id="container-summary">
      <div class="steps" style="margin-bottom: -60px;">
        <usb-steps-reservation>
        </usb-steps-reservation>
      </div>
      <div class="mt-4" style="border-radius: 5px;" [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">
        <div class="d-flex" style="padding-top: 50px;">
          <div style="width: 100%; margin-top: 30px; padding-left: 60px; margin-right: 30px;">
            <div >
              <h5 class="itinerary-nro" [ngStyle]="{'color':getClientsSettingAppBooking?.clients_setting_global?.color_main_3}">FILE N° {{id}} </h5>
              <p class="m-0 itinerary-date">Fecha de Creación: {{ itineraryItems?.created_at| date: 'dd/MM/yyy' }}</p>
              <p class="itinerary-date">Modificación: {{ itineraryItems?.updated_at | date:'dd/MM/yyy' }}</p>
              <h4 class="client-data" *ngIf="itineraryClient?.first_name">
                {{ itineraryClient?.first_name + ' ' + itineraryClient?.last_name }}</h4>
              <div class="row mt-5 ml-0 mr-0 py-1 bar-detail">
                <p class="m-0 ml-3 dark-1 d-flex align-items-center">
                  <img src="/assets/img/app/little-icons/user.svg" class="icon-adult-people">
                  <!-- itineraryItems.totalAdultsMax -->
                  <span class="text-bar-detail">&nbsp;&nbsp;{{ qtyAdults }} {{ qtyAdults  > 1 ? 'Adultos' : 'Adulto'}}</span>
                </p>
                <p class="m-0 ml-3 dark-1 d-flex align-items-center">
                  <img src="/assets/img/app/little-icons/child.svg" class="icon-adult-people">
                  <span class="text-bar-detail">&nbsp;&nbsp;{{ qtyChilds }} {{ qtyChilds  > 1 ? 'Niños' : 'Niño'}}</span>
                </p>
                <p *ngIf="validateHotel()" class="m-0 ml-3 dark-1 d-flex align-items-center">
                  <i class="icon i-bed"></i>
                  <!-- userService.itineraryQtyNights -->
                  <span class="text-bar-detail">&nbsp;&nbsp;{{ totalNights }} {{ totalNights  > 1 ? 'Noches' : 'Noche'}}</span>
                </p>
                 <p class="m-0 ml-3 dark-1 d-flex align-items-center" *ngIf="userService.verifyCategory('RENT-A-CAR')">
                   <img src="../../assets/img/app/categories-search-box/car-compact.svg" style="width: 18px;" alt="">
                  <span class="text-bar-detail">&nbsp;&nbsp;{{userService.verifyQuantityCategory('RENT-A-CAR')}} Rent-a-car</span>
                </p>
                 <p class="m-0 ml-3 dark-1 d-flex align-items-center" *ngIf="userService.verifyCategory('TRANSPORTS')">
                   <img src="../../assets/img/app/categories-search-box/bus.svg" style="width: 18px;" alt="">
                  <span class="text-bar-detail">&nbsp;&nbsp;{{userService.verifyQuantityCategory('TRANSPORTS')}} {{userService.verifyQuantityCategory('TRANSPORTS') > 1 ? 'Traslados' : 'traslado'}}</span>
                </p>
                <p class="m-0 ml-3 dark-1 d-flex align-items-center" *ngIf="userService.verifyCategory('TOURS')">
                   <img src="../../assets/img/app/categories-search-box/road-map.svg" style="width: 18px;" alt="">
                  <span class="text-bar-detail">&nbsp;&nbsp;{{userService.verifyQuantityCategory('TOURS')}} {{userService.verifyQuantityCategory('TOURS') > 1 ? 'Experiencias' : 'Experiencia'}}</span>
                </p>
                <p class="m-0 ml-3 dark-1 d-flex align-items-center" *ngIf="userService.verifyCategory('TICKET')">
                  <img src="../../assets/img/app/categories-search-box/combi-ticket.svg" style="width: 18px;" alt="">
                  <span class="text-bar-detail">&nbsp;&nbsp;{{userService.verifyQuantityCategory('TICKETS')}} {{userService.verifyQuantityCategory('TICKETS') > 1 ? 'Tickets' : 'Ticket'}}</span>
                </p>
                <p class="m-0 ml-3 dark-1 d-flex align-items-center" *ngIf="userService.verifyCategory('INSURANCE')">
                  <img src="../../assets/img/app/categories-search-box/icon-seguro.svg" style="width: 18px;" alt="">
                  <span class="text-bar-detail">&nbsp;&nbsp;{{userService.verifyQuantityCategory('INSURANCE')}} {{userService.verifyQuantityCategory('INSURANCE') > 1 ? 'Asistencias' : 'Asistencia'}} </span>
                </p>
              </div>
            </div>
          </div>
          <div  style="border-left:solid 3px white;">
            <div class="d-flex flex-column" style="margin-left: 20px; margin-right: 12px; margin-top: 30px;">
              <div class="row">
                <div class="col-2">
                  <span class="icon-check-green"></span>
                </div>
                <div class="col-10" *ngIf="userService.itineraryActive.length > 0">
                  <h5 class="succesfully-text" *ngIf="itineraryItems.status_id == 1">EL FILE FUE COTIZADO CON ÉXITO EN MODO QUOTE</h5>
                  <h5 class="succesfully-text" *ngIf="itineraryItems.status_id == 2">EL FILE FUE COTIZADO CON ÉXITO EN MODO PARCIAL </h5>
                  <h5 class="succesfully-text" *ngIf="itineraryItems.status_id == 3">EL FILE FUE COTIZADO CON ÉXITO EN MODO RESERVADO</h5>
                  <h5 class="succesfully-text" *ngIf="itineraryItems.status_id == 4">EL FILE FUE COTIZADO CON ÉXITO EN MODO DENEGADO</h5>
                  <h5 class="succesfully-text" *ngIf="itineraryItems.status_id == 5">EL FILE FUE COTIZADO CON ÉXITO EN MODO CANCELADO</h5>
                  <h5 class="succesfully-text" *ngIf="itineraryItems.status_id == 6">EL FILE FUE COTIZADO CON ÉXITO EN MODO COMPLETADO</h5>
                </div>
              </div>

              <div class="d-flex flex-column justify-content-center">
              <div class="row ml-1" style="margin-top: 80px;">
                <div class="col-2">
                  <img class="icon-premium" src="../../assets/img/app/little-icons/badge-bks.png" alt="logo bks"
                  style="margin-top: 5px; margin-left: 5px;">
                </div>
                <div class="col-10">
                  <div class="" style="color:#ff9900 !important;">
                    <div *ngIf="!loaded">
                      <a class="loader text-center justify-content-center" *ngIf="!pointCategory">
                        <i class="fa fa-spinner fa-spin"></i>
                      </a>
                    </div>
                    <p class="text-points col-6 pl-0" style="color: #facb49; margin-bottom: -5px"> Sumaste </p>
                    <p class="text-points col-6 pl-0" style="color: #facb49">{{pointCategory | number: '1.2-2'}}&nbsp;Blickoins </p>
                  </div>
                </div>
              </div>
              <div class="row mx-auto">
                  <div class="pl-2 pr-2 pb-1" style="border-radius: 5px; background-color:#facb49 ; margin-top: -14px; margin-left:35px;">
                    <div *ngIf="!loaded">
                      <a class="loader text-center justify-content-center" *ngIf="!totalPointGlobal">
                        <i class="fa fa-spinner fa-spin"></i>
                      </a>
                    </div>
                    <div class="d-flex flex-column align-items-start">
                    <p class="text-points m-0" [ngStyle]="{'color':getClientsSettingAppBooking?.clients_setting_global?.color_main_2}"> Total&nbsp;{{ pointsAvailable | number: '1.2-2' }}&nbsp;Blickoins </p>
                    <p class="text-points-after" style="margin-top: -6px; margin-bottom: 0;" [ngStyle]="{'color':getClientsSettingAppBooking?.clients_setting_global?.color_main_2}"> Después de este viaje </p>
                  </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
        <div style="border-left:solid 3px white; width: 69%;">

            <div class="adjust-price" style="margin: 30px 40px 30px 35px;">
              <div>
                <h5 class="m-0 text-uppercase text-status" *ngIf="itineraryItems.state" style="color: #00d397;">
                  <span *ngIf="itineraryItems.state.name === 'Quote'">quote</span>
                  <span *ngIf="itineraryItems.state.name === 'Reserve'">reservado</span>
                  <span *ngIf="itineraryItems.state.name === 'Partial Reserve'">reserva parcial</span>
                  <span *ngIf="itineraryItems.state.name === 'Cancelled'">cancelado</span>
                  <span *ngIf="itineraryItems.state.name === 'Denied'">denegado</span>
                  <span *ngIf="itineraryItems.state.name === 'Completed'">completado</span>
                </h5>
              </div>


              <div class="row font-weight-bold mt-2">
                <div class="col-6 d-flex flex-column">
                  <div class="text-price" style="height: 18px;">
                    TARIFA TOTAL:
                  </div>
                  <div style="font-size: 11px; font-weight: 300">
                    incluye impuesto
                  </div>
                </div>
                  <div class="col-6 d-flex justify-content-end align-items-center price text-nowrap">
                    <span class="d-flex">
                      <p class="mb-0" *ngIf="itineraryItems?.items && itineraryItems?.items.length > 0">
                        {{currencyAgency?.code}}  {{getTotalTarifa() | number: '1.2-2'}}

                      </p>
                      <usb-tooltip-convert-amount
                                            [clientsSettingAppBooking]="getClientsSettingAppBooking"
                                            [currencyProduct]="currencyAgency?.code"
                                            [valueProduct]="getTotalTarifa()"
                                            >
                      </usb-tooltip-convert-amount>
                    </span>
                  </div>
              </div>
              <div class="row font-weight-bold mt-2">
                <div class="col-6 d-flex align-items-center text-price">
                  COMISIÓN
                </div>
                <div class="col-6 d-flex align-items-center justify-content-end comision text-nowrap">
                  <!-- {{currencyItinerary}} {{ (this.itineraryItems.totalFee ? this.itineraryItems.totalFee : 0) | number:'1.2-2'  }} -->
                   <span class="d-flex">
                        <p class="mb-0" *ngIf="itineraryItems?.items && itineraryItems?.items.length > 0">
                          {{currencyAgency?.code}} {{getComission() | number: '1.2-2'}}
                        </p>
                         <usb-tooltip-convert-amount
                                            [clientsSettingAppBooking]="getClientsSettingAppBooking"
                                            [currencyProduct]="currencyAgency?.code"
                                            [valueProduct]="getComission()"
                                            >
                      </usb-tooltip-convert-amount>
                   </span>
                </div>
              </div>

              <div class="row font-weight-bold mt-2">
                <div class="col-6 fee-text">
                  FEE:
                </div>
                <div class="col-6 d-flex align-items-center justify-content-end text-right" style="font-size: 20px;">
                  {{ itineraryItems.percentageFee ? itineraryItems.percentageFee : 0 }} %
                </div>
              </div>

              <div class="row mt-3 px-1 py-2 ml-0 mr-0" style="border-radius: 5px; border: solid 1px white;">
                <div class="col-7 p-0 pl-2 d-flex align-items-center net-price-text mt-1">
                  TARIFA NETA RESERVA
                </div>
                <!-- <div *ngIf="itineraryItems.totalNetPriceBookingFreeTax === 0" class="col-5 p-0 pr-1 justify-content-end net-price text-nowrap mt-1">

                  {{currencyItinerary}} {{ this.itineraryItems?.totalPriceByNetReserved | number:'1.2-2'  }}
                </div> -->
                <div class="col-5 p-0 pr-1 justify-content-end net-price text-nowrap mt-1">
                  <!--  $ {{ userService.totalNetReserved | number:'1.2-2'  }}-->
                     <span class="d-flex">
                     <p class="mb-0" *ngIf="itineraryItems?.items && itineraryItems?.items.length > 0">
                       {{currencyAgency?.code}} {{ (getTotalTaxesForStatus2() > 0 ? getTotalFreeTax() : getTotalTarifaReserve()) | number:'1.2-2'  }}

                    </p>
                      <usb-tooltip-convert-amount
                                            [clientsSettingAppBooking]="getClientsSettingAppBooking"
                                            [currencyProduct]="currencyAgency?.code"
                                            [valueProduct]="getTotalTaxesForStatus2() > 0 ? getTotalFreeTax() : getTotalTarifaReserve()"
                                            >
                      </usb-tooltip-convert-amount>
                     </span>
                </div>

                <div *ngIf="totalTaxPrice > 0" class="col-7 p-0 pl-2 d-flex align-items-center net-price-text mt-2">
                  IMPUESTO
                </div>
                <div *ngIf="totalTaxPrice > 0" class="col-5 p-0 pr-1 justify-content-end net-price text-nowrap mt-2">
                  <!--  $ {{ userService.totalNetReserved | number:'1.2-2'  }}-->
                  <!-- Descomentar en caso que se vuelva a usar $ {{ itineraryItems.totalTaxPrice | number:'1.2-2'  }} -->

                  <!-- {{currencyItinerary}} {{ totalTaxPrice | number:'1.2-2'  }} -->
                   <span class="d-flex">
                     <p class="mb-0" *ngIf="itineraryItems?.items && itineraryItems?.items.length > 0">
                   {{currencyAgency?.code}} {{getTotalTaxesForStatus2()}}
                     </p>
                      <usb-tooltip-convert-amount
                                            [clientsSettingAppBooking]="getClientsSettingAppBooking"
                                            [currencyProduct]="currencyAgency?.code"
                                            [valueProduct]="getTotalTaxesForStatus2()"
                                            >
                      </usb-tooltip-convert-amount>
                     </span>
                </div>
                <div class="col-7 p-0 pl-2 d-flex align-items-center net-price-text mt-2">
                  TARIFA TOTAL RESERVA
                </div>
                <div class="col-5 p-0 pr-1 justify-content-end net-price text-nowrap mt-2">
                  <!-- {{currencyItinerary}} {{  this.itineraryItems?.totalPriceByReserved | number:'1.2-2'  }} -->
                   <span class="d-flex">
                     <p class="mb-0" *ngIf="itineraryItems?.items && itineraryItems?.items.length > 0">
                        {{currencyAgency?.code}} {{getTotalTarifaReserve() | number: '1.2-2'}}
                           </p>
                      <usb-tooltip-convert-amount
                                            [clientsSettingAppBooking]="getClientsSettingAppBooking"
                                            [currencyProduct]="currencyAgency?.code"
                                            [valueProduct]="getTotalTarifaReserve()"
                                            >
                      </usb-tooltip-convert-amount>
                   </span>
                </div>
              </div>

              <div class="container">
                <div class="row mt-3" style="align-items: center;">
                    <div *ngIf="permissionsMap['booking.itinerarios.liquidacion']" class="col-2 d-flex justify-content-center" >
                    <i tooltip="Descargar liquidación" placement="bottom" class="liquidation" style="cursor: pointer; padding: 23px !important" (click)="downloadLiquidation(itineraryItems.id);"></i>
                  </div>
                  <div *ngIf="permissionsMap['booking.itinerarios.pagar'] && buttonPay && searchProductReserved()" class="col-10" style="text-align: end;">
                    <button class="btn btn-pay" type="button" (click)="pay()" style=" border-radius: 50px;width:100%"
                    [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_3}">
                      Pagar</button>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div  id="container-detail-reserve" style="font-family: Poppins;">
    <ng-container *ngIf="partialReserve===false">
      <div class="resumen-summary-content justify-content-center resumen pt-5 pl-5 pr-5">
        <h4 class="text-uppercase text-status-service" *ngIf="itineraryItems.state"> PRODUCTOS
          {{itineraryItems.state.name ? itineraryItems.state.name : ''}} LISTADO</h4>
        <div class="mt-4">
          <ng-container *ngFor="let item of itineraryItems.items, let i = index">

            <hr class="mt-1" style="border-top: 1px dotted #4e4e4e !important;" *ngIf="i >= 1">
            <div class="row p-2 justify-content-between">
              <div class="col-9 item-descrption">
                <div class="row">
                  <div class="col-1 p-0 d-flex justify-content-center">
                    <div class="icon-itinerary-activity d-flex justify-content-center align-items-center">
                        <img width="26px"
                              [src]="getIconCategory(item.categoryName, item)"
                            alt="">
                    </div>
                  </div>
                  <div class="col-9" *ngIf="item.categoryName=='HOTELS'">
                    <h5 class="font-weight-bold m-0 text-capitalize title-product">{{item.title}}</h5>
                    <p class="mt-1 m-0 text-location">{{item.roomType}}</p>
                    <p class="mt-1 m-0 text-location">{{item.rateClassId  === "R" ? 'Reembolsable' : 'No Reembolsable'}}</p>
                    <p class="font-weight-bold mt-1 m-0 text-location">
                      <i class="bi bi-geo-alt-fill" aria-hidden="true" style="font-size: 14px; color:#00d398"></i>
                      {{item.location}}</p>
                    <span class="mt-1"><b>Pasajeros: </b> {{ item?.adults }} {{item?.adults > 1 ? 'adultos' : 'adulto'}}, {{item?.paxChildren}} {{item?.paxChildren > 1 ? 'niños' : 'niño'}} {{item?.paxChildren > 0 ? getAgesInItem(item) : ''}}</span>
                    <p>
                      <b>Pasajero: </b>
                      <span class="ml-1" *ngIf="item?.status_id === 1">{{ itineraryItems?.paxList[0]?.first_name || '' }} {{ itineraryItems?.paxList[0]?.last_name || '' }}</span>
                      <span class="ml-1" *ngIf="item?.status_id === 2 && item && item?.resultReserve && item?.resultReserve?.paxList?.length > 0">{{ item?.resultReserve?.paxList[0]?.firstName || '' }} {{ item?.resultReserve?.paxList[0]?.lastName || '' }} </span>
                    </p>
                  </div>
                  <div class="col-9" *ngIf="item.categoryName=='TOURS'">
                    <h5 class="font-weight-bold m-0 text-capitalize title-product">{{item.title}}</h5>
                     <p *ngIf="item.productName" class="m-0 text-pick-up"> <span class="font-weight-bold">Inicio: </span>{{item.productName}}</p>
                      <p *ngIf="item.experience?.sessions" class="m-0 text-pick-up"> <span class="font-weight-bold">Inicio: </span>{{item.experience?.sessions}} hs.</p>
                      <p *ngIf="item.experience?.language" class="m-0 text-pick-up"> <span class="font-weight-bold">Idioma: </span>{{item.experience?.language}}</p>
                      <p *ngIf="getDurationTour(item) !== ''" class="m-0 text-pick-up"> <span class="font-weight-bold">Duración: </span>{{getDurationTour(item)}}</p>

                      <p class="mt-1 m-0 text-location">{{item.rateClassId  === "R" ? 'Reembolsable' : 'No Reembolsable'}}</p>

                     <p class="font-weight-bold mt-1 m-0 text-location">
                      <i class="bi bi-geo-alt-fill" aria-hidden="true" style="font-size: 14px; color:#00d398"></i>
                      {{stingUpperCase(getLocation(item))}}</p>
                       <span class="mt-1"><b>Pasajeros: </b> {{ item?.paxAdults }} {{item?.paxAdults > 1 ? 'adultos' : 'adulto'}}, {{item?.paxChildren}} {{item?.paxChildren > 1 ? 'niños' : 'niño'}} {{item?.paxChildren > 0 ? getAgesInItem(item) : ''}}</span>
                      <p *ngIf="item?.status_id === 1">
                        <b>Pasajero: </b>
                        <span class="ml-1">{{ itineraryItems?.paxList[0]?.first_name || '' }} {{ itineraryItems?.paxList[0]?.last_name || '' }}</span>
                      </p>
                      <p *ngIf="item?.status_id === 2 && item && item?.resultReserve && item?.resultReserve?.paxList?.length > 0">
                        <b>Pasajero: </b>
                        <span class="ml-1">{{ item?.resultReserve?.paxList[0]?.firstName || '' }} {{ item?.resultReserve?.paxList[0]?.lastName || '' }} </span>
                      </p>
                  </div>
                  <div class="col-9" *ngIf="item.categoryName=='RENT-A-CAR'">
                    <h5 class="font-weight-bold m-0 text-capitalize title-product">{{item.title}}</h5>
                    <p class="mt-1 m-0 text-location">{{item.type}} - {{item.type_definition}}</p>
                    <p class="mt-1 m-0 text-location">{{item.rateClass  === "R" ? 'Reembolsable' : 'No Reembolsable'}}</p>
                    <div class="font-poppins location-text m-0 mt-2">
                      <p class="font-weight-bold mt-1 m-0 text-location">
                        <i class="bi bi-geo-alt-fill" aria-hidden="true" style="font-size: 14px; color:#00d398"></i>

                        <span>{{stingUpperCase(getLocation(item))}}</span>
                      </p>

                    </div>
                     <span class="mt-1"><b>Pasajeros: </b> {{ item?.paxAdults }} {{item?.paxAdults > 1 ? 'adultos' : 'adulto'}}, {{item?.paxChildren}} {{item?.paxChildren > 1 ? 'niños' : 'niño'}} {{item?.paxChildren > 0 ? getAgesInItem(item) : ''}}</span>
                    <p>
                      <b>Pasajero: </b>
                      <span class="ml-1" *ngIf="item?.status_id === 1">{{ itineraryItems?.paxList[0]?.first_name || '' }} {{ itineraryItems?.paxList[0]?.last_name || '' }}</span>
                      <span class="ml-1" *ngIf="item?.status_id === 2 && item && item?.resultReserve && item?.resultReserve?.paxList?.length > 0">{{ item?.resultReserve?.paxList[0]?.firstName || '' }} {{ item?.resultReserve?.paxList[0]?.lastName || '' }} </span>
                    </p>
                    <!-- <p class="mt-1 m-0 text-location">{{item.rateClass  === "R" ? 'Reembolsable' : 'No Reembolsable'}}</p> Confirmación de que llegan las políticas de cancelación -->
                   </div>
                  <div class="col-9" *ngIf="item.categoryName=='TRANSPORTS'">
                    <h5 class="font-weight-bold m-0 text-capitalize title-product">{{item.title}}</h5>
                    <div class="font-poppins d-flex flex-column location-text m-0 mt-2">
                       <span>

                        <span *ngIf="item?.firstWay"><b>{{item.firstWay === 1 ? 'IDA' : 'VUELTA'}}</b></span>
                      </span>
                      <span>
                        <i class="bi bi-geo-alt-fill" aria-hidden="true" style="font-size: 14px; color:#00d398"></i>
                        <span>Pickup: {{stingUpperCase(extractNameTransport(item, 'origin'))}}</span>
                      </span>
                      <span>
                        <i class="bi bi-geo-alt-fill" aria-hidden="true" style="font-size: 14px; color:#00d398"></i>
                        <span>Dropoff: {{stingUpperCase(extractNameTransport(item, 'destination'))}}</span>
                      </span>
                      <span>
                        <!-- <i class="bi bi-geo-alt-fill" aria-hidden="true" style="font-size: 14px; color:#00d398"></i> -->
                        <span class="ml-1"> Punto de inicio: {{stingUpperCase(extractAddressType(item, 'origin'))}}</span>
                      </span>
                      <span>
                        <!-- <i class="bi bi-geo-alt-fill" aria-hidden="true" style="font-size: 14px; color:#00d398"></i> -->
                        <span class="ml-1"> Punto de llegada: {{stingUpperCase(extractAddressType(item, 'destination'))}}</span>
                      </span>
                       <span class="mt-1"><b>Pasajeros: </b> {{ item?.paxAdults }} {{item?.paxAdults > 1 ? 'adultos' : 'adulto'}}, {{item?.paxChildren}} {{item?.paxChildren > 1 ? 'niños' : 'niño'}} {{item?.paxChildren > 0 ? getAgesInItem(item) : ''}}</span>

                      <p>
                        <b>Pasajero: </b>
                        <span class="ml-1" *ngIf="item?.status_id === 1">{{ itineraryItems?.paxList[0]?.first_name || '' }} {{ itineraryItems?.paxList[0]?.last_name || '' }}</span>
                        <span class="ml-1" *ngIf="item?.status_id === 2 && item && item?.resultReserve && item?.resultReserve?.paxList?.length > 0">{{ item?.resultReserve?.paxList[0]?.firstName || '' }} {{ item?.resultReserve?.paxList[0]?.lastName || '' }} </span>
                      </p>
                    </div>
                  </div>
                  <div class="col-9" *ngIf="item.categoryName=='FLIGHTS'">
                    <h5 class="font-weight-bold m-0 text-capitalize title-product">{{item.title}}</h5>
                    <p class="mt-1 m-0 text-location">{{item.itinerary?.[0]?.options?.[0]?.segments?.[0]?.airline?.name}}</p>
                    <p class="mt-1 m-0 text-location">{{item.itinerary?.[0]?.options?.[0]?.segments?.[0]?.cabin?.category}}</p>
                    <p class="mt-1 m-0 text-location">{{item.rateClassId === "R" ? 'Reembolsable' : 'No Reembolsable'}}</p>
                    <p class="font-weight-bold mt-1 m-0 text-location">
                      <i class="bi bi-geo-alt-fill" aria-hidden="true" style="font-size: 14px; color:#00d398"></i>
                      {{item.origin}} > {{item.destinationAirport}}</p>
                      <span class="mt-1"><b>Pasajeros: </b> {{ item?.paxAdults }} {{item?.paxAdults > 1 ? 'adultos' : 'adulto'}}, {{item?.paxChildren}} {{item?.paxChildren > 1 ? 'niños' : 'niño'}} {{item?.paxChildren > 0 ? getAgesInItem(item) : ''}}</span>
                      <p>
                        <b>Pasajero: </b>
                        <span class="ml-1">{{ itineraryItems?.paxList[0]?.first_name || '' }} {{ itineraryItems?.paxList[0]?.last_name || '' }}</span>
                        <!-- <span class="ml-1" *ngIf="item?.status_id === 2 && item && item?.resultReserve && item?.resultReserve?.paxList?.length > 0">{{ item?.resultReserve?.paxList[0]?.firstName || '' }} {{ item?.resultReserve?.paxList[0]?.lastName || '' }} </span> -->
                      </p>
                  </div>
                  <div class="col-9" *ngIf="item.categoryName=='INSURANCE'">
                    <h5 class="font-weight-bold m-0 text-capitalize title-product">{{item.title}}</h5>
                    <!-- <p class="mt-1 m-0 text-location">{{item.description}}</p> -->
                    <p class="mt-1 m-0 text-location">{{item.trip?.tripType}}</p>
                    <p class="mt-1 m-0 text-location">{{item.rateClass  === "R" ? 'Reembolsable' : 'No Reembolsable'}}</p>
                    <p class="font-weight-bold mt-1 m-0 text-location">
                      <!-- <i class="icon-placeholder font-verde"></i> -->
                      <i class="bi bi-geo-alt-fill" aria-hidden="true" style="font-size: 14px; color:#00d398"></i>
                      {{item.form?.begin}} > {{item.form?.destination?.name || item.form.destination}}</p>
                      <span class="mt-1"><b>Pasajeros: </b> {{ item?.paxAdults }} {{item?.paxAdults > 1 ? 'adultos' : 'adulto'}}, {{item?.paxChildren}} {{item?.paxChildren > 1 ? 'niños' : 'niño'}} {{item?.paxChildren > 0 ? getAgesInItem(item) : ''}}</span>
                      <p>
                        <b>Pasajero: </b>
                        <span class="ml-1" *ngIf="item?.status_id === 1">{{ itineraryItems?.paxList[0]?.first_name || '' }} {{ itineraryItems?.paxList[0]?.last_name || '' }}</span>
                        <span class="ml-1" *ngIf="item?.status_id === 2 && item && item?.resultReserve && item?.resultReserve?.paxList?.length > 0">{{ item?.resultReserve?.paxList[0]?.firstName || '' }} {{ item?.resultReserve?.paxList[0]?.lastName || '' }} </span>
                      </p>
                  </div>
                </div>
              </div>
              <div class="col-3 px-0 d-flex flex-column align-items-end">
                <span class="d-flex flex-row" style="gap: 1em;">
                  <div *ngIf="permissionsMap['booking.itinerarios.voucher'] && item.status_id !== 1 && item.status_id !== 5">
                    <div class="d-flex flex-row justify-content-center container-btn-tickets">
                      <i class="i-voucher mr-2" *ngIf="item.status != 'Quote'" (click)="vouchersReservationPdf(item.id)"
                        visible="item.status_id!=2 && item.status_id!=5"></i>
                    </div>
                  </div>
                  <div class="p-2 d-flex justify-content-between align-items-center " [ngClass]="{
                                'product-status-saved': item.status_id === 1,
                                'product-status-reserved': item.status_id === 2,
                                'product-status-locked': item.status_id === 3,
                                'product-status-denied': item.status_id === 4,
                                'product-status-cancelled': item.status_id === 5,
                                'product-status-paid-agency': item.status_id === 6,
                                'product-status-paid-provider': item.status_id === 7,
                                'product-status-billed': item.status_id === 8,
                                'product-status-pending-approve-pay': item.status_id === 9,
                                'product-status-completed': item.status_id === 10
                              }" style="border-radius: 5px; width:8.5em;">
                    <span class="icon-check"></span>
                    <h5 class="m-0 font-weight-bold text-white" style="font-size: 14px;">
                      {{item.status}}
                    </h5>
                  </div>
                </span>
                <!-- Este bloque de TARIFA es genérico para todas las categorías. Para HOTELS se le suma
                     item.room.pricing.taxesExcluded (impuestos no incluidos, a pagar en destino) solo
                     acá en el render — item.netPriceAgent sigue siendo el total real, sin tocar. -->
                <div class="d-flex flex-column row m-0 mt-2 align-items-end justify-content-center" *ngIf="item.status_id != 5">

                  <div class="d-flex" >
                    <p class="m-0" style="font-size:16px;color: #454545"> <span class="font-weight-bold">TARIFA: </span>
                      <!-- {{currencyItinerary}} {{ item.optionNightsNetTotalProf | number:'1.2-2'  }}  -->
                          {{currencyAgency?.code}} {{ (item.netPriceAgent + (item.categoryName === 'HOTELS' ? (item.room?.pricing?.taxesExcluded || 0) : 0))
                                      | currencyConverterPure:
                                        item.currency:
                                        currencyAgency?.code:
                                        currencies
                                      | number: '1.2-2'}}
                    </p>
                     <usb-tooltip-convert-amount
                                            [clientsSettingAppBooking]="getClientsSettingAppBooking"
                                            [currencyProduct]="item.currency"
                                            [valueProduct]="item.netPriceAgent + (item.categoryName === 'HOTELS' ? (item.room?.pricing?.taxesExcluded || 0) : 0)"
                                            >
                    </usb-tooltip-convert-amount>
                  </div>
                    <p class="font-weight-bold" style="font-size: 11px;" class="mb-0">inc. impuesto</p>

                    <div *ngIf="item.currency !== currencyAgency?.code">
                      <div class="d-flex">
                        <p
                        style="height: auto; font-weight: 400;font-size: 12px"
                        >{{item.currency}} {{ (item.netPriceAgent + (item.categoryName === 'HOTELS' ? (item.room?.pricing?.taxesExcluded || 0) : 0)) | number:'1.2-2'}}</p>
                        <div class="info-tool d-flex flex-column position-relative">
                          <img src="../../../assets/icons/admi_01.svg" width="12px" alt="">
                          <span class="tooltip-info shadow-md">
                            <div class="d-flex justify-content-center align-items-center px-2 py-1">
                              <p class="mb-0" style="font-size: 14px;color: black;">{{userService.messageProviderAmount}}</p>
                            </div>
                          </span>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
            </div>
            <div class="row p-2 mt-2 justify-content-between" *ngIf="item.categoryName=='HOTELS'" style="border-top:solid 1px #272849; margin-left: 70px; margin-right: -4px;">
              <div class="col-3 item-descrption pl-0" style="width: 40rem;">
                <div *ngIf="item.status_id==1" class="row m-0" style="width: 30rem;">
                  <p class="m-0 text-pick-up" style="width: 20rem; color: #d20358; font-weight: 500;"> <span class="font-weight-bold pr-1"> Resultado de reserva: </span>
                    {{ item.resultReserve}} </p>
                </div>
                <div class="row m-0">
                  <p class="m-0 text-pick-up"> <span class="font-weight-bold pr-1">Fecha Inicio: </span>
                    {{ item.arrivalDate | date:'mediumDate' }} </p>
                </div>
                <div class="row m-0 mt-1">
                  <p class="m-0 text-pick-up" style="line-height: 7px;">
                    <div class="row m-0">
                      <p class="m-0 text-pick-up"> <span class="font-weight-bold">Fecha Fin:</span>
                        {{ item.departureDate | date:'mediumDate' }} </p>
                    </div>
                </div>
                <div class="row m-0 mt-1">
                  <p class="m-0 text-pick-up" style="line-height: 7px;">
                    <div class="row m-0">
                      <p class="m-0 text-pick-up"> <span class="font-weight-bold">Check In:</span>
                        {{ item.checkTimes.checkIn  ? item.checkTimes.checkIn : 'N/A'}} </p>
                    </div>
                </div>
                <div class="row m-0 mt-1">
                  <p class="m-0 text-pick-up" style="line-height: 7px;">
                    <div class="row m-0">
                      <p class="m-0 text-pick-up"> <span class="font-weight-bold">Check Out:</span>
                        {{ item.checkTimes.checkOut ? item.checkTimes.checkOut : 'N/A'}} </p>
                    </div>
                </div>
                <div class="row m-0 mt-1"  *ngIf="item.status_id==2">
                  <p class="m-0 text-pick-up"> <span class="font-weight-bold pr-1">Localizador: </span>
                    {{item?.resultReserve?.providerReservationId }} </p>  <!--Locator -->
                      <i class="bi bi-clipboard-check text-semiblack ml-1" style="cursor: pointer;" (click)="copyToClipboard(item?.resultReserve?.providerReservationId)"></i>
                </div>
              </div>
              <div class="col-4 item-descrption px-0" style="margin-left: 20rem;">
                <div class="text-right mt-2" *ngIf="item.rateClassId == 'R'">
                  <p class="m-0 text-expiration text-align-end font-weight-bold pb-1"> POLITICA DE CANCELACIÓN </p>
                  <div class="row m-0 justify-content-end" *ngIf="item?.room?.cancellationPolicy && item?.room?.cancellationPolicy.length > 0">
                    <p class="m-0 text-expiration mt-1" [ngClass]="{'canc-gratis': item.rateClassId == 'R'}">Hasta: {{item?.room?.cancellationPolicy[0]?.from | date:'dd/MM/yyyy h:mm ' }}</p>
                    <p class="m-0 text-expiration mt-1 ml-3" [ngClass]="{'canc-gratis': item.rateClassId == 'R'}"> Gratis</p>
                  </div>
                  <div *ngIf="item?.room?.cancellationPolicy && item?.room?.cancellationPolicy.length > 0" class="row m-0 justify-content-end">
                    <p class="m-0 text-expiration mt-1" style="font-weight:500;color:#d60159">{{item?.room?.cancellationPolicy[0]?.descript_polecy}}</p>
                    <p class="m-0 text-expiration mt-1" style="font-weight:500;color:#d60159">Desde: {{item?.room?.cancellationPolicy[0]?.from | date:'dd/MM/yyyy h:mm ' }}</p>
                    <p class="m-0 text-expiration mt-1 ml-3" style="font-weight:500;color:#d60159">

                                                                                                         {{currencyAgency?.code}} {{ item?.room?.cancellationPolicy[0]?.amount
                                                                                                                                    | currencyConverterPure:
                                                                                                                                      item.currency:
                                                                                                                                      currencyAgency?.code:
                                                                                                                                      currencies
                                                                                                                                    | number: '1.2-2'}}
                                                                                                    </p>
                                                                                                    <usb-tooltip-convert-amount
                                                                                                                              [clientsSettingAppBooking]="getClientsSettingAppBooking"
                                                                                                                              [currencyProduct]="item.currency"
                                                                                                                              [valueProduct]="item?.room?.cancellationPolicy[0]?.amount"
                                                                                                                              >
                                                                                                  </usb-tooltip-convert-amount>
                    </div>
                </div>
                <div class="text-right mt-2" *ngIf="item.rateClassId === 'NR'">
                  <p class="m-0 text-expiration text-align-end font-weight-bold pb-1"> POLITICA DE CANCELACIÓN </p>
                  <div class="row m-0 justify-content-end">
                    <p class="m-0 text-expiration mt-1" style="font-weight:500;color:#d60159">{{item?.room?.cancellationPolicy[0]?.descript_polecy}}</p>
                    <p class="m-0 text-expiration mt-1" style="font-weight:500;color:#d60159"> Una vez reservado </p>
                    <p class="m-0 text-expiration mt-1 ml-3" style="font-weight:500;color:#d60159">  100%  </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="row p-2 mt-2 justify-content-between" *ngIf="item.categoryName=='TOURS'" style="border-top:solid 1px #272849; margin-left: 70px; margin-right: -4px;">
              <div class="col-3 item-descrption pl-0" style="width: 40rem;">
                <div class="row m-0">
                  <p class="m-0 text-pick-up"> <span class="font-weight-bold pr-1">Fecha Inicio: </span>
                    {{ item.arrivalDate | date:'mediumDate' }} </p>
                </div>
                <div class="row m-0 mt-1">
                  <p class="m-0 text-pick-up" style="line-height: 7px;">
                    <div class="row m-0">
                      <p class="m-0 text-pick-up"> <span class="font-weight-bold">Fecha Fin:</span>
                        {{ item.departureDate | date:'mediumDate' }} </p>
                    </div>
                </div>
                <div class="row m-0 mt-1"  *ngIf="item.status_id==2">
                  <p class="m-0 text-pick-up"> <span class="font-weight-bold pr-1">Localizador: </span>
                    {{item?.resultReserve?.providerReservationId }}</p>   <!--Locator -->
                  <i class="bi bi-clipboard-check text-semiblack ml-1" style="cursor: pointer;" (click)="copyToClipboard(item?.resultReserve?.providerReservationId)"></i>
                </div>
              </div>
              <div class="col-4 item-descrption px-0 " style="margin-left: 20rem;">
                <div class="text-right mt-2" *ngIf="item.rateClassId == 'R'">
                  <p class="m-0 text-expiration text-align-end font-weight-bold pb-1"> POLITICA DE CANCELACIÓN </p>
                  <div class="row m-0 justify-content-end" >
                    <p class="m-0 text-expiration mt-1" [ngClass]="{'canc-gratis': item.rateClassId == 'R'}">Hasta: {{item?.experience?.cancellation_policy[0]?.dateFrom | date:'dd/MM/yyyy h:mm ' }}</p>
                    <p class="m-0 text-expiration mt-1 ml-3" [ngClass]="{'canc-gratis': item.rateClassId == 'R'}"> Gratis</p>
                  </div>
                  <div class="row m-0 justify-content-end">
                    <p class="m-0 text-expiration mt-1" style="font-weight:500;color:#d60159">Desde: {{item?.experience?.cancellation_policy[0]?.dateFrom | date:'dd/MM/yyyy h:mm ' }}</p>
                    <p class="m-0 text-expiration mt-1 ml-3" style="font-weight:500;color:#d60159">

                                                                                                         {{currencyAgency?.code}} {{item?.cancellationPolicies?.cancellationPolicies[0]?.amount
                                                                                                                                    | currencyConverterPure:
                                                                                                                                      item.currency:
                                                                                                                                      currencyAgency?.code:
                                                                                                                                      currencies
                                                                                                                                    | number: '1.2-2'}}
                                                                                                    </p>
                                                                                                    <usb-tooltip-convert-amount
                                                                                                                              [clientsSettingAppBooking]="getClientsSettingAppBooking"
                                                                                                                              [currencyProduct]="item.currency"
                                                                                                                              [valueProduct]="item?.cancellationPolicies[0]?.amount"
                                                                                                                              >
                                                                                                  </usb-tooltip-convert-amount>
                    </div>
                </div>
                <div class="text-right mt-2" *ngIf="item.rateClassId === 'NR'">
                  <p class="m-0 text-expiration text-align-end font-weight-bold pb-1"> POLITICA DE CANCELACIÓN </p>
                  <div class="row m-0 justify-content-end">
                    <!-- <p class="m-0 text-expiration mt-1" style="font-weight:500;color:#d60159">{{item?.cancellationPolicies[0]?.descript_polecy}}</p> -->
                    <p class="m-0 text-expiration mt-1" style="font-weight:500;color:#d60159"> Una vez reservado </p>
                    <p class="m-0 text-expiration mt-1 ml-3" style="font-weight:500;color:#d60159">  100%  </p>
                  </div>
                </div>
              </div>
            </div>


            <div class="row p-2 mt-2" *ngIf="item.categoryName=='RENT-A-CAR'"
              style="border-top:solid 1px #272849; margin-left: 70px; margin-right: -4px;">

              <div class="col-6 item-descrption pl-0 mt-1">
                  <div class="row m-0">
                  <p class="m-0 text-pick-up"> <span class="font-weight-bold">Fecha de inicio: </span>
                    {{ item.arrivalDate | date:'mediumDate' }} </p>
                </div>

                <div class="row m-0">
                  <p class="m-0 text-pick-up"> <span class="font-weight-bold">Recogida: </span>
                    {{ item.pickupname }} </p>
                </div>

                <div class="row m-0">
                  <p class="m-0 text-pick-up"> <span class="font-weight-bold">Fecha de Finalización</span>
                    {{ item.departureDate | date:'mediumDate' }} </p>
                </div>
                <div class="row m-0">
                  <p class="m-0 text-pick-up"> <span class="font-weight-bold">Devolución: </span>
                    {{ item.dropoffname }} </p>
                </div>
                <div class="row m-0">
                  <p class="m-0 text-pick-up"> <span class="font-weight-bold">Conductor Principal: </span>
                        {{ item.resultReserve?.additionalInfo?.reservationDetailCarRental?.paxes[0].firstName + " " + item.resultReserve?.additionalInfo?.reservationDetailCarRental?.paxes[0].lastName }}
                  </p>
                </div>
                 <div class="row m-0">
                  <p class="m-0 text-pick-up"> <span class="font-weight-bold">Localizador: </span>  {{ item.resultReserve?.providerReservationId }} </p>
                         <i class="bi bi-clipboard-check text-semiblack ml-1" style="cursor: pointer;" (click)="copyToClipboard(item?.resultReserve?.reservation?.providerReservationId)"></i>
                </div>

              </div>

              <div class="col-6 item-descrption px-0" >
                <div class="text-right mt-2" *ngIf="item.rateClass == 'R'">
                  <p class="m-0 text-expiration text-align-end font-weight-bold pb-1"> POLITICA DE CANCELACIÓN </p>
                  <div class="row m-0 justify-content-end" >
                    <p class="m-0 text-expiration mt-1" [ngClass]="{'canc-gratis': item.rateClass == 'R'}">{{item?.cancellationPolicies[0]?.descript_polecy}}</p>
                    <p class="m-0 text-expiration mt-1" [ngClass]="{'canc-gratis': item.rateClass == 'R'}">Hasta: {{item?.cancellationPolicies[0]?.from | date:'dd/MM/yyyy h:mm ' }}</p>
                    <p class="m-0 text-expiration mt-1 ml-3" [ngClass]="{'canc-gratis': item.rateClass == 'R'}"> Gratis</p>
                  </div>
                  <div class="row m-0 justify-content-end">
                    <p class="m-0 text-expiration mt-1" style="font-weight:500;color:#d60159">{{item?.cancellationPolicies[0]?.descript_polecy}}</p>
                    <p class="m-0 text-expiration mt-1" style="font-weight:500;color:#d60159">Desde: {{item?.cancellationPolicies[0]?.from | date:'dd/MM/yyyy h:mm ' }}</p>
                    <p class="m-0 text-expiration mt-1 ml-3" style="font-weight:500;color:#d60159">
                                                                                                          {{currencyAgency?.code}} {{item?.cancellationPolicies[0]?.amount
                                                                                                                                    | currencyConverterPure:
                                                                                                                                      item.currency:
                                                                                                                                      currencyAgency?.code:
                                                                                                                                      currencies
                                                                                                                                    | number: '1.2-2'}}
                    </p>
                  </div>
                </div>
                <div class="text-right mt-2" *ngIf="item.rateClass === 'NR'">
                  <p class="m-0 text-expiration text-align-end font-weight-bold pb-1"> POLITICA DE CANCELACIÓN </p>
                  <div class="row m-0 justify-content-end">
                    <p class="m-0 text-expiration mt-1" style="font-weight:500;color:#d60159">{{item?.cancellationPolicies[0]?.descript_polecy}}</p>
                    <p class="m-0 text-expiration mt-1" style="font-weight:500;color:#d60159"> Una vez reservado </p>
                    <p class="m-0 text-expiration mt-1 ml-3" style="font-weight:500;color:#d60159"> 100% </p> <!--  {{currencyItinerary}} {{item?.cancellationPolicies[0]?.amount | number: '1.2-2'}} -->
                  </div>
                </div>
              </div>


            </div>





            <div class="row p-2 mt-2 mb-4 justify-content-between" *ngIf="item.categoryName=='TRANSPORTS'"
              style="border-top:solid 1px #272849; margin-left: 70px; margin-right: -4px;">
              <div class="col-6 item-descrption pl-0 mt-1">
                <div class="row m-0">
                  <p class="m-0 text-pick-up"> <span class="font-weight-bold">Fecha de inicio: </span>
                    {{ item.arrivalDate | date:'mediumDate' }} - ({{item.payload[0].transfers.pickupTime}} hs. - {{getMessageFirstTime(item.payload[0].transfers.pickupLocation, 'origin')}})</p>
                </div>

                <div class="row m-0">
                  <p class="m-0 text-pick-up"> <span class="font-weight-bold">Localizador: </span> {{ item.resultReserve?.providerReservationId}}</p>
                  <i class="bi bi-clipboard-check text-semiblack ml-1" style="cursor: pointer;" (click)="copyToClipboard(item?.resultReserve?.providerReservationId)"></i>
                </div>

              </div>
              <div class="col-6 item-descrption px-0" >
                <div class="text-right mt-2" *ngIf="item.pricing.rateClass == 'R'">
                  <p class="m-0 text-expiration text-align-end font-weight-bold pb-1"> POLITICA DE CANCELACIÓN </p>
                  <div class="row m-0 justify-content-end" >
                    <p class="m-0 text-expiration mt-1" [ngClass]="{'canc-gratis': item.pricing.rateClass == 'R'}">{{item?.cancellationPolicies[0]?.descript_polecy}}</p>
                    <p class="m-0 text-expiration mt-1" [ngClass]="{'canc-gratis': item.pricing.rateClass == 'R'}">Hasta: {{item?.cancellationPolicies[0]?.from | date:'dd/MM/yyyy h:mm ' }}</p>
                    <p class="m-0 text-expiration mt-1 ml-3" [ngClass]="{'canc-gratis': item.pricing.rateClass == 'R'}"> Gratis</p>
                  </div>
                  <div class="row m-0 justify-content-end">
                    <p class="m-0 text-expiration mt-1" style="font-weight:500;color:#d60159">{{item?.cancellationPolicies[0]?.descript_polecy}}</p>
                    <p class="m-0 text-expiration mt-1" style="font-weight:500;color:#d60159">Desde: {{item?.cancellationPolicies[0]?.from | date:'dd/MM/yyyy h:mm ' }}</p>
                    <p class="m-0 text-expiration mt-1 ml-3" style="font-weight:500;color:#d60159">
                                                                                                      {{currencyAgency?.code}} {{item?.cancellationPolicies[0]?.amount
                                                                                                                                    | currencyConverterPure:
                                                                                                                                      item.currency:
                                                                                                                                      currencyAgency?.code:
                                                                                                                                      currencies
                                                                                                                                    | number: '1.2-2'}}
                    </p>
                  </div>
                </div>
                <div class="text-right mt-2" *ngIf="item.pricing.rateClass === 'NR'">
                  <p class="m-0 text-expiration text-align-end font-weight-bold pb-1"> POLITICA DE CANCELACIÓN </p>
                  <div class="row m-0 justify-content-end">
                    <p class="m-0 text-expiration mt-1" style="font-weight:500;color:#d60159">{{item?.cancellationPolicies[0]?.descript_polecy}}</p>
                    <p class="m-0 text-expiration mt-1" style="font-weight:500;color:#d60159"> Una vez reservado </p>
                    <p class="m-0 text-expiration mt-1 ml-3" style="font-weight:500;color:#d60159"> 100% </p> <!--  {{currencyItinerary}} {{item?.cancellationPolicies[0]?.amount | number: '1.2-2'}} -->
                  </div>
                </div>
              </div>
            </div>

            <div class="row p-2 mt-2 justify-content-between" *ngIf="item.categoryName=='FLIGHTS'" style="border-top:solid 1px #272849; margin-left: 70px; margin-right: -4px;">
              <div class="col-3 item-descrption pl-0" style="width: 40rem;">
                <div class="row m-0">
                  <p class="m-0 text-pick-up"> <span class="font-weight-bold pr-1">Fecha Salida: </span>
                    {{ item.arrivalDate | date:'mediumDate' }} </p>
                </div>
                <div class="row m-0 mt-1" *ngIf="item.returnDate">
                  <p class="m-0 text-pick-up" style="line-height: 7px;">
                    <div class="row m-0">
                      <p class="m-0 text-pick-up"> <span class="font-weight-bold">Fecha Regreso:</span>
                        {{ item.returnDate | date:'mediumDate' }} </p>
                    </div>
                </div>
                <div class="row m-0 mt-1"  *ngIf="item.status_id==2">
                  <p class="m-0 text-pick-up"> <span class="font-weight-bold pr-1">Localizador: </span>
                    {{item?.resultReserve?.providerReservationId }}</p>   <!--Locator -->
                  <i class="bi bi-clipboard-check text-semiblack ml-1" style="cursor: pointer;" (click)="copyToClipboard(item?.resultReserve?.providerReservationId)"></i>
                </div>
              </div>
              <div class="col-4 item-descrption px-0 " style="margin-left: 20rem;">
                <div class="text-right mt-2" *ngIf="item.rateClassId == 'R'">
                  <p class="m-0 text-expiration text-align-end font-weight-bold pb-1"> POLITICA DE CANCELACIÓN </p>
                  <div class="row m-0 justify-content-end" >
                    <p class="m-0 text-expiration mt-1" [ngClass]="{'canc-gratis': item.rateClassId == 'R'}">Hasta: {{item?.cancellationPolicies?.[0]?.from | date:'dd/MM/yyyy h:mm ' }}</p>
                    <p class="m-0 text-expiration mt-1 ml-3" [ngClass]="{'canc-gratis': item.rateClassId == 'R'}"> Gratis</p>
                  </div>
                  <div class="row m-0 justify-content-end">
                    <p class="m-0 text-expiration mt-1" style="font-weight:500;color:#d60159">{{item?.cancellationPolicies?.[0]?.descript_polecy}}</p>
                    <p class="m-0 text-expiration mt-1" style="font-weight:500;color:#d60159">Desde: {{item?.cancellationPolicies?.[0]?.from | date:'dd/MM/yyyy h:mm ' }}</p>
                    <p class="m-0 text-expiration mt-1 ml-3" style="font-weight:500;color:#d60159">
                                                                                                         {{currencyAgency?.code}} {{item?.cancellationPolicies?.[0]?.amount
                                                                                                                                    | currencyConverterPure:
                                                                                                                                      item.currency:
                                                                                                                                      currencyAgency?.code:
                                                                                                                                      currencies
                                                                                                                                    | number: '1.2-2'}}
                                                                                                    </p>
                                                                                                    <usb-tooltip-convert-amount
                                                                                                                              [clientsSettingAppBooking]="getClientsSettingAppBooking"
                                                                                                                              [currencyProduct]="item.currency"
                                                                                                                              [valueProduct]="item?.cancellationPolicies?.[0]?.amount"
                                                                                                                              >
                                                                                                  </usb-tooltip-convert-amount>
                    </div>
                </div>
                <div class="text-right mt-2" *ngIf="item.rateClassId === 'NR'">
                  <p class="m-0 text-expiration text-align-end font-weight-bold pb-1"> POLITICA DE CANCELACIÓN </p>
                  <div class="row m-0 justify-content-end">
                    <p class="m-0 text-expiration mt-1" style="font-weight:500;color:#d60159"> Una vez reservado </p>
                    <p class="m-0 text-expiration mt-1 ml-3" style="font-weight:500;color:#d60159">  100%  </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="row p-2 mt-2 justify-content-between" *ngIf="item.categoryName=='INSURANCE'" style="border-top:solid 1px #272849; margin-left: 70px; margin-right: -4px;">
              <div class="col-3 item-descrption pl-0" style="width: 40rem;">
                <div class="row m-0">
                  <p class="m-0 text-pick-up"> <span class="font-weight-bold pr-1">Fecha Inicio: </span>
                    {{ item.arrivalDate | date:'mediumDate' }} </p>
                </div>
                <div class="row m-0 mt-1">
                  <p class="m-0 text-pick-up" style="line-height: 7px;">
                    <div class="row m-0">
                      <p class="m-0 text-pick-up"> <span class="font-weight-bold">Fecha Fin:</span>
                        {{ item.departureDate | date:'mediumDate' }} </p>
                    </div>
                </div>
                <div class="row m-0 mt-1"  *ngIf="item.status_id==2">

                  <p class="m-0 text-pick-up"> <span class="font-weight-bold pr-1">Localizador: </span>
                    {{item?.resultReserve?.reservation?.providerReservationId }}</p>   <!--Locator -->
                  <i class="bi bi-clipboard-check text-semiblack ml-1" style="cursor: pointer;" (click)="copyToClipboard(item?.resultReserve?.reservation?.providerReservationId)"></i>
                </div>
              </div>
              <div class="col-4 item-descrption px-0 " style="margin-left: 20rem;">
                <div class="text-right mt-2" *ngIf="item.rateClass == 'R'">
                  <p class="m-0 text-expiration text-align-end font-weight-bold pb-1"> POLITICA DE CANCELACIÓN </p>
                  <div class="row m-0 justify-content-end" >
                    <p class="m-0 text-expiration mt-1" [ngClass]="{'canc-gratis': item.rateClass == 'R'}">{{item?.cancellationPolicies[0]?.descript_polecy}}</p>
                    <p class="m-0 text-expiration mt-1" [ngClass]="{'canc-gratis': item.rateClass == 'R'}">Hasta: {{item?.cancellationPolicies[0]?.from | date:'dd/MM/yyyy h:mm ' }}</p>
                    <p class="m-0 text-expiration mt-1 ml-3" [ngClass]="{'canc-gratis': item.rateClass == 'R'}"> Gratis</p>
                  </div>
                  <div class="row m-0 justify-content-end">
                    <p class="m-0 text-expiration mt-1" style="font-weight:500;color:#d60159">{{item?.cancellationPolicies[0]?.descript_polecy}}</p>
                    <p class="m-0 text-expiration mt-1" style="font-weight:500;color:#d60159">Desde: {{item?.cancellationPolicies[0]?.from | date:'dd/MM/yyyy h:mm ' }}</p>
                    <p class="m-0 text-expiration mt-1 ml-3" style="font-weight:500;color:#d60159">

                                                                                                         {{currencyAgency?.code}} {{item?.cancellationPolicies[0]?.amount
                                                                                                                                    | currencyConverterPure:
                                                                                                                                      item.currency:
                                                                                                                                      currencyAgency?.code:
                                                                                                                                      currencies
                                                                                                                                    | number: '1.2-2'}}
                                                                                                    </p>
                                                                                                    <usb-tooltip-convert-amount
                                                                                                                              [clientsSettingAppBooking]="getClientsSettingAppBooking"
                                                                                                                              [currencyProduct]="item.currency"
                                                                                                                              [valueProduct]="item?.cancellationPolicies[0]?.amount"
                                                                                                                              >
                                                                                                  </usb-tooltip-convert-amount>
                    </div>
                </div>
                <div class="text-right mt-2" *ngIf="item.rateClass === 'NR'">
                  <p class="m-0 text-expiration text-align-end font-weight-bold pb-1"> POLITICA DE CANCELACIÓN </p>
                  <div class="row m-0 justify-content-end">
                    <p class="m-0 text-expiration mt-1" style="font-weight:500;color:#d60159"> Una vez reservado </p>
                    <p class="m-0 text-expiration mt-1 ml-3" style="font-weight:500;color:#d60159">  100%  </p>
                  </div>
                </div>
              </div>
            </div>

          </ng-container>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="partialReserve===true">
      <div class="resumen resumen-summary-content pt-5 pl-5 pr-5">
        <usb-services-details-summary [itineraryItems]="itineraryItems.items" [partialReserve]="partialReserve">
        </usb-services-details-summary>
      </div>
    </ng-container>

    <div class="important-container d-flex flex-column justify-content-start"
    [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_2}" style="margin-top:40px">

      <div class="d-flex justify-content-center align-items-center" style="margin-top: 25px;">
        <i class="icon-important mr-3"></i>
        <span id="important-title">
          IMPORTANTE
        </span>
      </div>
      <br>
      <div class="row justify-content-center adjust-important-information" style="margin-left: 110px; width: 999px;">

        <div class="col-9">
          <ul class="numbered-list-circle" style="color:white !important;">
            <li class="d-flex align-items-center">
              <div class="d-flex number-circle justify-content-center align-items-center mr-3">
                <p class="m-0">01</p>
              </div>
              <!-- You can re-edit, cancel or make a reservation for this itinerary, go to -->
              <p class="text-list-important m-0">Puede volver a editar, cancelar o hacer una reserva para este file, ir a
                <a (click)="goToItinerary()"
                  style="cursor: pointer !important;color:white !important; font-weight: bold; text-transform: uppercase;">VER MIS FILES.</a>
              </p>
            </li>

            <li class="d-flex align-items-center mt-4">
              <div class="d-flex number-circle justify-content-center align-items-center mr-3">
                <p class="m-0">02</p>
              </div>
              <!-- You can re-edit, cancel or make a reservation for this itinerary, go to -->
              <p class="text-list-important m-0">El tipo de cambio se confirma al momento de realizar el pago

            </li>

            <li class="d-flex align-items-center mt-4" *ngIf="dateFromCancellation">
              <div class="d-flex number-circle justify-content-center align-items-center mr-3">
                <p class="m-0">03</p>
              </div>
              <!-- This itinerary may suffer price changes from the date -->
              <p *ngIf="dateFromCancellation" class="text-list-important m-0">Este file puede sufrir cambios de tarifa a partir del {{dateFromCancellation | date:'dd/MM/yyyy'  }}
                <span style="color:white !important; font-weight: bold;"></span>
              </p>
            </li>
          </ul>
        </div>
      </div>

    </div>


    <ng-container *ngIf="partialReserve===true">
      <!-- Next Saved Draf -->

    </ng-container>
    <div class="resumen p-4 mt-4" *ngIf="partialReserve===false" style="margin-bottom: 255px;">
      <ng-container>

        <div class="row mb-4">

          <div class="col-12">
            <p id="important-title" class="d-flex justify-content-center" style="color: #000000 !important">¿QUÉ TE GUSTARÍA HACER?</p>
          </div>

        </div>

        <div class="row">
          <div class="col-2">
          </div>
          <div class="col-8">
            <div class="row">
              <div class="col text-center" style="border-right: solid #000000  3px;">
                <div class="d-flex justify-content-center mb-2">

                  <a (click)="goManagament()" style="cursor: pointer;">
                    <span  class="go-itinerary"></span>
                  </a>
                </div>
                <a class="mt-2" (click)="goManagament()" style="font-family: 'Poppins'; font-size: 14px; font-weight: 400;cursor: pointer !important;color: #00d397;">IR A FILE</a>
              </div>

              <div class="col text-center">
                <div class="d-flex justify-content-center">

                  <a (click)="liduidationItinerayPdf()"  style="cursor: pointer;">
                    <span class="liquidation" style="padding: 36px !important"></span>
                  </a>
                </div>
                <a class="mt-2" (click)="liduidationItinerayPdf()" style="font-size: 14px !important; cursor: pointer !important;color: #00d397;"> LIQUIDACIÓN
                </a>
              </div>

              <div style="display: none;" class="col text-center">
                <div class="d-flex justify-content-center">

                  <span class="go-pdf"></span>
                </div>

                <a type="submit" class="btn-pdf-email mt-2" (click)="goToDownloadPdf()" style="font-family: 'Poppins'; font-size: 14px; font-weight: 400; color: #d20358;" name="btn-pdf"
                  tooltip="Download PDF" placement="bottom">
                  DESCARGAR PDF
                </a>
              </div>

              <div  class="col text-center" style="border-left: solid #000000  3px; display: none;" >
                <div class="d-flex justify-content-center">

                  <span class="go-mail"></span>
                </div>

                <a type="submit" class="btn-pdf-email mt-2" (click)="openModal(template)" name="btn-mail" style="font-family: 'Poppins'; font-size: 14px; font-weight: 400; color: #00d397;"
                  tooltip="Send Mail" placement="bottom">
                  ENVIAR MAIL
                </a>
              </div>

            </div>

          </div>

          <div class="col-2">


          </div>
        </div>

      </ng-container>
    </div>
  </div>



</div>

<ng-template #template>
  <form method="POST">
    <div class="modal-body text-center">
      <p>"Esto guardará su file actual y comenzará un nuevo borrador de file. ¿Está seguro?"</p>
      <button type="button" data-placement="bottom" class="btn btn-sm btn-usblick" title="Yes" (click)="sendMail()">SI</button>
      <button type="button" class="btn btn-outline-danger btn-sm" (click)="closeModal()">NO</button>
    </div>
  </form>
</ng-template>




